import * as actionTypes from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsErrorModalVisibleState */

/** @type {IsErrorModalVisibleState} */
const initialState = false;

const set = () => true;
const reset = () => false;

export default createReducer(initialState, {
  [actionTypes.OPEN_WORK_ORDER_ERROR_MODAL]: set,
  [actionTypes.CLOSE_WORK_ORDER_ERROR_MODAL]: reset,
  [actionTypes.FETCH_WORKS_ORDER_FAILURE]: set,
  [LOCATION_CHANGE]: reset,
});
